import { TierKey } from 'generated/types'
import { getPageViewEvent } from 'utils/analytics'

type EventDataArgs = {
  tierKey: TierKey
  tierPrice: number
  funnel: string
}

type EventData = {
  type: 'button_tapped' | 'screen_viewed'
  object_name: string
  screen: 'registrationChooseSubscription'
  screen_name: 'registrationChooseSubscription'
  tierKey: TierKey
  tierPrice: number
  funnel: string
  destination?: string
}

export const getScreenViewEventData = (args: EventDataArgs): EventData => {
  return {
    type: 'screen_viewed',
    object_name: 'registrationChooseSubscription',
    screen: 'registrationChooseSubscription',
    screen_name: 'registrationChooseSubscription',
    tierKey: args.tierKey,
    tierPrice: args.tierPrice,
    funnel: args.funnel,
  }
}

export const getChangeTierButtonTappedEventData = (args: EventDataArgs): EventData => {
  return {
    type: 'button_tapped',
    object_name: 'registrationChooseSubscription',
    screen: 'registrationChooseSubscription',
    screen_name: 'registrationChooseSubscription',
    tierKey: args.tierKey,
    tierPrice: args.tierPrice,
    funnel: args.funnel,
  }
}

export const getConfirmButtonTappedEventData = (args: EventDataArgs): EventData => {
  return {
    type: 'button_tapped',
    object_name: 'registrationChooseSubscriptionConfirm',
    screen: 'registrationChooseSubscription',
    screen_name: 'registrationChooseSubscription',
    tierKey: args.tierKey,
    tierPrice: args.tierPrice,
    funnel: args.funnel,
    destination: 'registrationInvestInterstitial',
  }
}

export const getBackButtonTappedEventData = (args: EventDataArgs): EventData => {
  const currentReferrer = window.history?.state?.state?.referrer
  const pageViewEventReferrer =
    currentReferrer && getPageViewEvent({ pathname: currentReferrer }, args.funnel)
  const backScreenName = pageViewEventReferrer?.screen_name || ''

  return {
    type: 'button_tapped',
    object_name: 'registrationChooseSubscriptionBack',
    screen: 'registrationChooseSubscription',
    screen_name: 'registrationChooseSubscription',
    tierKey: args.tierKey,
    tierPrice: args.tierPrice,
    funnel: args.funnel,
    destination: backScreenName,
  }
}
